import { Button, DateInput, Input, Modal } from "components"
import moment from "moment"
import { Fragment, useState } from "react"
import { toast } from "react-hot-toast"
import { useApi, useToggle } from "utils"
import { FormStateProjectProfile } from "../types/ProfileTypes"

type ModalDeleteProps = {
  data: Pick<
    FormStateProjectProfile,
    | "project_id"
    | "trx_code"
    | "project_name"
    | "department_name"
    | "start_date"
    | "employee_name"
    | "customer_name"
  >
  modalState: ReturnType<typeof useToggle>
  onSuccess?: () => void
}

export const ModalDeleteProject = ({
  data,
  modalState,
  onSuccess
}: ModalDeleteProps) => {
  const [loadingData, setLoadingData] = useState(false)
  const api = useApi()
  const params = {
    project_id:data.project_id
  }

  const handleDeleteData = async () => {
    setLoadingData(true)
    await toast
      .promise(api.delete(`project/delete`,{params}), {
        loading: "Loading...",
        success: (res) => res?.data?.message,
        error: (err) => err?.response?.data?.message
      })
      .then(() => {
        modalState.setActive(false)
        onSuccess?.()
      })
      .finally(() => {
        setLoadingData(false)
      })
  }

  return (
    <Modal
      isOpen={modalState.isActive}
      title="DELETE PROJECT"
      size="xl"
      closeModal={modalState.toggle}>
      <Modal.Body>
        <Fragment>
          <small className="text-lg font-medium text-red-400">
            Are you sure want to delete this data?
          </small>

          <Input disabled label="PROJECT ID#" defaultValue={data.trx_code} />
          <Input disabled label="PROJECT NAME" defaultValue={data.project_name} />
          <Input
            disabled
            label="DEPARTMENT"
            defaultValue={data.department_name}
          />
          <Input disabled label="MANAGER" defaultValue={data.employee_name} />

          <Input disabled label="SPONSOR" defaultValue={data.customer_name} />

          <DateInput
            disabled
            label="DATE"
            selected={moment(data.start_date).toDate()}
            onChange={() => null}
          />
        </Fragment>
      </Modal.Body>

      <Modal.Footer>
        <Button
          type="button"
          color="error"
          disabled={loadingData}
          loading={loadingData ? "true" : undefined}
          onClick={handleDeleteData}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
